import { render, staticRenderFns } from "./WorkspaceMachineViewTable.vue?vue&type=template&id=b4fda8ca&scoped=true"
import script from "./WorkspaceMachineViewTable.vue?vue&type=script&lang=js"
export * from "./WorkspaceMachineViewTable.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMachineViewTable.vue?vue&type=style&index=0&id=b4fda8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fda8ca",
  null
  
)

export default component.exports